const CurrencyFormatter = ({ children }) => {
    // 空欄の場合の処理
    if (children === undefined || children === null || children === '') {
      return <span>－</span>;
    }
  
    // 数値の場合の処理
    if (!isNaN(children)) {
      const formattedNumber = new Intl.NumberFormat('ja-JP', { style: 'currency', currency: 'JPY' }).format(children);
      return <span>{formattedNumber}</span>;
    }
  
    // 数値以外の場合はそのまま表示
    return <span>{children}</span>;
  };
  
  export default CurrencyFormatter;